import axiosInstance from "../../utils/axiosInterceptor";
import { reducersActions } from "./new-actions";

const {
  GET_COLLECTIONS_REQUEST,
  GET_COLLECTIONS_SUCCESS,
  GET_COLLECTIONS_FAILURE,
} = reducersActions;

export const fetchFilteredCollections = (page = 1, filters = {}) => {
  return async (dispatch) => {
    dispatch({ type: GET_COLLECTIONS_REQUEST });

    try {
      const queryParams = new URLSearchParams({
        page: page.toString(),
        ...filters,
      });

      const response = await axiosInstance.get(`${process.env.REACT_APP_BASE_URL_VMS}/api/v3/collections?${queryParams}`);

      dispatch({
        type: GET_COLLECTIONS_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: GET_COLLECTIONS_FAILURE,
        payload: error.response?.data?.message || error.message,
      });
    }
  };
};
